import { WeightUnit } from "./admin.graphql";

export const weightUnitToGrams = (
  weight?: { unit: WeightUnit; value?: number | null } | null,
): number | undefined => {
  if (!weight || !weight.value) {
    return undefined;
  }
  switch (weight.unit) {
    case WeightUnit.Grams:
      return weight.value;
    case WeightUnit.Kilograms:
      return weight.value * 1000;
    case WeightUnit.Ounces:
      return weight.value * 28.3495;
    case WeightUnit.Pounds:
      return weight.value * 453.592;
    default:
      return weight.value;
  }
};
